import { useState } from 'react';
import { useSkuSelector } from '../hooks/useSkuSelector';
import FrameAround from './FrameAround';
import SelectorInternalBox from './SelectorInternalBox';

type SkuSizeSelectorProps = {
	children: React.ReactNode;
	value: string;
};

const CSS_HANDLES = ['skuSelectorItem'];
const SkuSizeSelectorItem = ({ children, value }: SkuSizeSelectorProps) => {
	const [selected, setSelected] = useState(false);
	const { blockClass, withModifiers, prodSum } = useSkuSelector();

	const renderClass = () => blockClass && `vtex-store-components-3-x-frameAround--${blockClass}`;

	const wm = withModifiers(CSS_HANDLES, selected ? 'selected' : '');

	return (
		<div
			role="button"
			className={`${prodSum ? wm : ''} skuSelectorItem skuSelectorItem--${blockClass}--${value} vtex-store-components-3-x-skuSelectorItem ${renderClass()} vtex-store-components-3-x-skuSelectorItem--${value} ${
				selected ? 'vtex-store-components-3-x-skuSelectorItem--selected skuSelectorItem--selected' : ''
			} relative di pointer flex items-center outline-0 ma2`}
			onClick={() => setSelected(!selected)}
		>
			{selected && <FrameAround selected={selected} />}
			<SelectorInternalBox selected={selected}>{children}</SelectorInternalBox>
		</div>
	);
};

export default SkuSizeSelectorItem;
